module.exports = __webpack_public_path__ + "img/FaultStatus.75e5e5f9.svg";